export default __webpack_public_path__ + "media/images/fluxod_40px2-adc3892d964e6f2e3d19fafba4415625.jpg";